import React, { Component } from 'react';

import $ from 'jquery';
import { Animated } from 'react-animated-css';
import { translate } from 'react-i18next';

//  ----------------   Form components
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';

//  ----------------   Custom Form components & validations
import { Email, required, email } from '../formValidation';

import './PassResetReqForm.css';

class PassResetReqForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    // input field animation code - adds class to current focused input field's parent
    if (value) {
      target.parentElement.classList.add('input--filled');
    } else {
      target.parentElement.classList.remove('input--filled');
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    // get data from all fields in form
    const data = this.form.getValues();

    $.ajax({
      url: '/api/v1/forgetPassword',
      type: 'POST',
      data: JSON.stringify(data),
      success: function (res) {

        this.props.notifySuccess(res.message);
      }.bind(this),
      error: function (err) {
        this.props.notifyError(err.responseJSON.message);
      }.bind(this)
    });
  }

  render() {
    return (
      <div>
        <Animated className="form-animation" animationIn="fadeInRight" animationOut="fadeOutLeft" isVisible={true}>

          <Form className="PassResetReqForm" ref={c => { this.form = c }} onSubmit={this.handleSubmit}>
            <h2 className="formTitle text-center mt-3">Esqueceu a senha</h2>

            <Email
              required
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
              id="email"
              name="email"
              type="email"
              value={this.state.email}
              className="input__field input__field--madoka"
              validations={[required, email]}
              onChange={this.handleInputChange} />

            <div className="form-group submitGroup form-row text-center">
              <Button type="submit" className="btn btn--submit mx-auto">Enviar</Button>
            </div>
          </Form>
        </Animated>

      </div>
    );
  }
}

export default (PassResetReqForm);



// WEBPACK FOOTER //
// ./src/components/PassResetReqForm/PassResetReqForm.js